import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { IconButton, Tooltip } from '@mui/material';
// eslint-disable-next-line import/no-extraneous-dependencies
import { MailOutline, DeleteOutlineOutlined } from '@mui/icons-material';
import '../../pages/Licenses/licenses.scss';
// eslint-disable-next-line import/no-extraneous-dependencies
import SignpostOutlinedIcon from '@mui/icons-material/SignpostOutlined';
// eslint-disable-next-line import/no-extraneous-dependencies
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import '../../pages/Licenses/licenses.scss';


/* eslint-disable i18next/no-literal-string */
const Actions = (context: any) => {
  // eslint-disable-next-line no-underscore-dangle
  const cellData = context.cell._cell.row.data;
  return (
      <>
         <Tooltip placement="top" title={context.props.t('CHANGE_EMAIL')}> 
          <IconButton
            onClick={() => {
              context.props.changeMail(cellData.id);
            }}
          >
            <MailOutline fontSize='small' color='info' />
          </IconButton>
         </Tooltip> 
        <Tooltip placement="top" title={context.props.t('FREE_LICENSE')}>
          <IconButton
            onClick={() => {
              context.props.freeLicense(cellData.id);
            }}
          >
            <DeleteOutlineOutlined fontSize='small' color='error' />
          </IconButton>
        </Tooltip>
        <Tooltip placement="top" title={context.props.t('LICENSE_TRANSACTIONS')}>
          <IconButton
            onClick={() => {
              context.props.openModalLicense(cellData.id);
              context.props.licenseTransactions(cellData.id);
            }}
            className='blueButtonTable'
          >
            <SignpostOutlinedIcon fontSize='small' color='info'/>
          </IconButton>
        </Tooltip>
        {cellData.activationDate !== null && (
          <Tooltip placement="top" title={context.props.t('CHANGE_LICENSE_EXPIRATION_DATE')}>
            <IconButton
              onClick={() => {
                context.props.changeLicenseExpirationDate(
                  cellData.id,
                  cellData.expirationDate,
                  cellData.activationDate
                );
                context.props.licenseTransactions(cellData.id);
              }}
            >
              <AccessTimeOutlinedIcon fontSize='small' color='info'/>
            </IconButton>
          </Tooltip>
        )}
        <Tooltip placement="top" title={context.props.t('ALGO_INFO')}>
          <IconButton
          style={{ 
            backgroundColor: cellData.activationTx ? '#1890ff' : 'lightgrey', 
            width: 30, height: 30, marginLeft: 5  
          }}
            onClick={() => {
              context.props.openAlgoInfo(cellData.activationTx);
              // context.props.algorandTransaction(cellData.activationTx);
            }}
          >
            <img style={{ height: 30 }} src="algorand_logo.svg" ></img>
          </IconButton>
        </Tooltip>
      </>
  );
};
  
export default Actions;